import React, { useState } from 'react';

const Sidebar = () => {
  // Only track which single menu is open
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  const toggleMenu = (menu: string) => {
    // If the clicked menu is already open, close it; otherwise open it and close others
    setOpenMenu(prev => (prev === menu ? null : menu));
  };

  return (
    <aside className="main-sidebar">
      <section className="sidebar position-relative">
        <div className="multinav">
          <div className="multinav-scroll" style={{ height: '100%' }}>
            <ul className="sidebar-menu" style={{ listStyleType: 'none' }}>

              {/* Dashboard */}
              <li className="treeview" style={{ listStyleType: 'none' }}>
                <a href="/dashboard" >
                  <i className="fa fa-th-large"></i>
                  <span>Dashboard</span>
                  {/* <span className="pull-right-container">
                    <i className={`fa ${openMenu === 'dashboard' ? 'fa-angle-down' : 'fa-angle-right'} pull-right`}></i>
                  </span> */}
                </a>
                {/* {openMenu === 'dashboard' && (
                  <ul className="treeview-menu" style={{ listStyleType: 'none' }}>
                    <li style={{ listStyleType: 'none' }}><a href="/overview"><i className="fa fa-circle"></i>Overview</a></li>
                  </ul>
                )} */}
              </li>

              {/* Family Search */}
              <li className="treeview">
                <a href="/patient-family-member" >
                  <i className="fa fa-users"></i>
                  <span>Family Search</span>
                  {/* <span className="pull-right-container">
                    <i className={`fa ${openMenu === 'patients' ? 'fa-angle-down' : 'fa-angle-right'} pull-right`}></i>
                  </span> */}
                </a>
                {/* {openMenu === 'patients' && (
                  <ul className="treeview-menu">
                    <li><a href="/family-profiles"><i className="fa fa-circle"></i>Family Profiles</a></li>
                  </ul>
                )} */}
              </li>

              {/* Appointments */}
              <li>
                <a href="/appointmentList">
                  <i className="fa fa-calendar"></i>
                  <span>Appointments</span>
                </a>
              </li>

              {/* Vital Reports */}
              <li className="treeview">
                <a href="#!" onClick={(e) => { e.preventDefault(); toggleMenu('vitals'); }}>
                  <i className="fa fa-file-text"></i>  {/* Changed icon here */}
                  <span>Vital Reports</span>
                  <span className="pull-right-container">
                    <i className={`fa ${openMenu === 'vitals' ? 'fa-angle-down' : 'fa-angle-right'} pull-right`}></i>
                  </span>
                </a>
                {openMenu === 'vitals' && (
                  <ul className="treeview-menu" style={{ listStyleType: 'none' }}>
                    <li><a href="/vitals-reports"><i className="fa fa-circle"></i>Vitals Reports</a></li>
                    <li><a href="/doctor-reports"><i className="fa fa-circle"></i>Doctor Reports</a></li>
                    <li><a href="/mytara-reports"><i className="fa fa-circle"></i>MyTara Reports</a></li>
                    <li><a href="/lab-reports"><i className="fa fa-circle"></i>Lab Reports</a></li>
                  </ul>
                )}
              </li>

              {/* Medication */}
              <li>
                <a href="/drug-interaction-alerts">
                  <i className="fa-solid fa-pills"></i>

                  <span>Medication</span>
                </a>
              </li>

            </ul>

            <div className="sidebar-widgets">
              <div className="copyright text-center m-25">
                <p>
                  <strong className="d-block">MyTara</strong>
                  © {new Date().getFullYear()} All Rights Reserved
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </aside>
  );
};

export default Sidebar;
